import { sortObjectKeys } from '@vindr/utils/helpers/common.helper';

export const formatDate = 'YYYYMMDD';
export const BASE_TIME = '19600101';
export const ROWS_PER_PAGE = Object.freeze([10, 25, 50, 100]);

export const ALL_USER_USERNAME_VALUE = '__all_user__';
export const FILTER_ALL_NAME = '__all__';

export const FILE_TYPES = Object.freeze({
  IMAGE: 'image',
  VIDEO: 'video',
  PDF: 'pdf',
  OTHER: 'other',
});

export const USER_STATUS = Object.freeze({
  INACTIVE: 0,
  ACTIVE: 1,
  EXPIRED: 2,
});

/* export const SURVEY_STATUS = Object.freeze({
  not_done: 'not_done',
  inprogress: 'inprogress',
  done: 'done',
}); */

export const GENDER = Object.freeze(['M', 'F', 'O']);

export const PANEL_TAB_NAMES = Object.freeze({
  AI_TAB: 'ai-tab',
  DOCTOR_TAB: 'doctor-tab',
});

export const FILTER_TYPE = Object.freeze([
  { name: 'Conditional Filter', value: 'cond' },
  { name: 'Unconditional Filter', value: 'no_cond' },
]);

export enum SORT_ORDER {
  ascend = 0,
  descend = 1,
  ASC = 0,
  DESC = 1,
  asc = 0,
  desc = 1,
}

export enum FILTER_MANAGEMENT_TYPE {
  'Conditional',
  'Unconditional',
}

export const INIT_GET_FILTER = sortObjectKeys({
  offset: 0,
  limit: 100,
});
